/**
 * ImportEmails
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button } from 'react-bootstrap';
import ImportWizard from '../../ImportWizard/index.jsx';
import messages from './messages.js';
import ConfirmSubmit from './ConfirmSubmit.jsx';

const typeData = {
  student: {
    title: messages.importParentMails,
    intro: messages.importParentMailsIntro,
    fileIntro: messages.selectParentsFileIntro,
    columns: ['firstName', 'middleName', 'lastName', 'birthDate', 'email1', 'email2'],
    template: '/Template_ouders_uitnodigen.xlsx',
    emailFields: ['email1', 'email2'],
  },
  employee: {
    title: messages.importEmployeeMails,
    intro: messages.importEmployeeMailsIntro,
    fileIntro: messages.selectFileIntro,
    columns: ['firstName', 'middleName', 'lastName', 'emailAddress'],
    template: '/Template_medewerkers_uitnodigen.xlsx',
    emailFields: 'emailAddress',
  },
};

function ImportEmails(props) {
  const { roleName, onSubmit } = props;
  const [show, setShow] = useState(false);
  const { title, intro, fileIntro, columns, template, emailFields } = typeData[roleName];

  function showConfirmSubmit(mappedData) {
    return (
      <ConfirmSubmit
        users={mappedData}
        emailFields={emailFields}
        roleName={roleName}
        onClose={() => setShow(false)}
        onSubmit={onSubmit}
      />
    );
  }

  return (
    <>
      <p className="form-text px-sm-4 pb-4"><FormattedMessage {...intro} /></p>
      <Button variant="primary" onClick={() => setShow(true)}><FormattedMessage {...messages.getStarted} /></Button>
      <ImportWizard
        show={show}
        onHide={() => setShow(false)}
        title={title}
        intro={fileIntro}
        columns={columns}
        template={template}
        showConfirmSubmit={showConfirmSubmit}
      />
    </>
  );
}

ImportEmails.propTypes = {
  roleName: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default ImportEmails;
